import { Company } from "../../../types/company/company";
import { CompanyDto } from "../../../types/company/company-dto";

export const convertCompanyDtoToCompany = (companyDto: CompanyDto): Company => {
  return {
    id: companyDto.id,
    name: companyDto.name,
    phone: companyDto.phone,
    status: companyDto.status,
    roles: companyDto.roles ?? [],
  };
};
